export const PURSE_KEYS = {
  PURSE_SOURCE_TYPES: ['PURSE_SOURCE_TYPES'],
  PURSE_DETAILS: (purseId: string, programId: number) => [
    'PURSE_DETAILS',
    purseId,
    programId,
  ],
  PURSES: (programId: number) => ['PROGRAM_PURSES', programId],
  PURSE_GRADES: (purseId: number, programId: number) => [
    'PURSE_GRADES',
    purseId,
    programId,
  ],
  TRANSACTION_LOGS: ({
    programId,
    purseId,
    page,
    perPage,
  }: {
    programId: number
    purseId: number
    page: number
    perPage: number
  }) => ['TRANSACTION_LOGS', programId, purseId, page, perPage],
  PURSE_DISTRIBUTIONS: (purseId: number, programId: number) => [
    'purse-distributions',
    purseId,
    programId,
  ],
  PURSE_AFFILIATIONS: (purseId: number, programId: number) => [
    'PURSE_AFFILIATIONS',
    purseId,
    programId,
  ],
  AWARDED_STUDENTS_PREVIEW: (programId: number, purseId: number) => [
    'AWARDED_STUDENTS_PREVIEW',
    programId,
    purseId,
  ],
}
